export const coconutCustard = {
  id: "coconutCustard",
  link: "/#/recipes/recipes/coconutCustard",
  name: "Coconut Custard",
  cuisine: "Alethi",
  summary: "Creamy coconut custard over a crumbly almond base",
  inspiration: null,
  quantity: "9",
  time: "45 minutes, plus time to chill",
  notes:
    "In the book, this dessert was served in some sort of large bowl or other container, not in individual squares like I've done here. But that was also at the Revel, where everything was being done in excess. I think it's completely reasonable that they would have taken a dessert normally eaten in small servings and filled an entire bowl with it. For the recipe, I prefer this serving style rather than a big bowl of custard.",
  quotes:
    "Kharat stuck his fingers into some kind of creamy dessert, taking it by the handful. (Oathbringer ch 78)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/coconut-squares-overview.jpg",
  ingredientSections: [
    {
      title: "Crust",
      ingredients: [
        {
          item: "nuts",
          display: "1 3/4 cups sliced almonds"
        },
        {
          item: "coconut",
          display: "1 cup unsweetened coconut flakes"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "cinnamon",
          display: "1/2 tsp ground cinnamon"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        }
      ]
    },
    {
      title: "Filling",
      ingredients: [
        {
          item: "eggs",
          display: "4 egg yolks"
        },
        {
          item: "sugar",
          display: "1/2 cup granulated sugar"
        },
        {
          item: "corn",
          display: "3 tbsp corn starch"
        },
        {
          item: "coconut",
          display: "2 cups coconut cream"
        },
        {
          item: "vanilla",
          display: "1 tsp vanilla extract"
        }
      ]
    }
  ],
  steps: [
    "Heat a large dry skillet over medium low heat. Add the sliced almonds and coconut flakes and toast, stirring frequently for 10 to 15 minutes or until most of the pieces are browned. The coconut may all brown before the nuts do, that's ok. Just be sure to take the pan off the heat before anything gets dark brown.",
    "Reserve 1/4 cup of the mixture. Take the rest and process in a food processor to coarse crumbs. Add honey, coconut oil, cinnamon, and salt. Process until combined and mixture can be pressed together.",
    "Line an 8 inch square pan with foil. Press mixture into the bottom of the pan to form the crust base. Place in the refrigerator to chill.",
    "For the filling, lightly beat the egg yolks in a bowl. Set aside. Mix the sugar and corn starch together in a saucepan. Add the coconut cream and mix well. Cook and stir over medium heat until thick and bubbly.",
    "Remove from heat. With the pot of thickened coconut cream mixture in one hand, and the whisk in the other, pour a thin stream of coconut cream mixture into the egg yolks, whisking the egg yolks as you do. The goal is to slowly combine the two without cooking the eggs. Continue to pour and whisk until you've poured about half the mixture.",
    "Reverse the process. Set the saucepan down, then pour a thin stream from the egg yolk bowl back into the pot, whisking the pot as you do so. Continue until everything has been returned to the pot. You should now have a yellow, somewhat thick mixture that does not have any cooked egg particles or chunks. If there is cooked egg, strain the mixture to remove the egg solids.",
    "Place the saucepan back over medium heat, cook until bubbly once more, then cook and stir for two more minutes.",
    "Remove from heat and mix in the vanilla. Pour the filling over the chilled crust. Sprinkle with the reserved toasted nut and coconut mixture.",
    "Place back in the refrigerator to chill until set. When ready to serve, slice into 9 squares."
  ]
}
